import angular from 'angular'
import template from './template.html'

function NominasCfdiDescargarComponent($q, $filter, $http, $file, $zip, NominasCfdiEmpresaNomina) {
  let $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.$onDestroy = $onDestroy;
  $ctrl.cerrar = cerrar;
  $ctrl.descargar = descargar;
  $ctrl.guardar = guardar;

  $ctrl.archivo = undefined;
  $ctrl.NominasCfdiEmpresaNomina = NominasCfdiEmpresaNomina;
  $ctrl.procesando = false;
  $ctrl.opciones = {pdf: true, xml: true, agrupar_nomina: true};
  $ctrl.progreso = 0;
  $ctrl.error = null;
  $ctrl.documentos = [];
  $ctrl.pendientes = [];
  $ctrl.completados = [];

  function $onInit() {
    $ctrl.timeout = $q.defer();
  }

  function $onDestroy() {
    $ctrl.timeout.resolve();
  }

  function descargar() {
    if ($ctrl.procesando) return;

    $ctrl.progreso = 0;
    $ctrl.procesando = true;
    $ctrl.error = null;

    $ctrl.documentos = [];
    $ctrl.completados = [];
    $ctrl.pendientes = [].concat($ctrl.seleccion);

    siguiente();
  }

  function siguiente() {
    if (!$ctrl.pendientes.length) {
      completado();

      return;
    }

    let nomina = $ctrl.pendientes.pop();

    return $http.get('/api/nominas/cfdi/empresa/nomina', {
        params: {
          id_proyecto: nomina.id_proyecto,
          id_nomina: nomina.id_nomina,
          pdf: $ctrl.opciones.pdf && 1 || 0,
          xml: $ctrl.opciones.xml && 1 || 0,
        },
        download: true,
        timeout: $ctrl.timeout.promise,
      })
      .then(function (response) {
        return $zip().then(function (zip) {
          return zip.loadAsync(response.data.content)
            .then(function (contents) {
              let promesas = [];

              angular.forEach(contents.files, function (file, filename) {
                let path = nomina.id_proyecto + '/' + ($ctrl.opciones.agrupar_nomina ? nomina.id_nomina + '/' : '');
                let promesa = convertir(file, path + filename)
                  .then(function (documento) {
                    $ctrl.documentos.push(documento)
                  });

                promesas.push(promesa);
              });

              return $q.all(promesas)
                .then(function () {
                  $ctrl.completados.push(nomina);

                  siguiente();
                });
            })
        })
      })
      .catch(function (response) {
        $ctrl.procesando = false;
        $ctrl.error = response && response.data || 'Se ha generado un error';
      })
      .finally(function () {
        $ctrl.progreso = $ctrl.completados.length / $ctrl.seleccion.length;
      });
  }

  function cerrar() {
    $ctrl.timeout.resolve();

    $ctrl.onClose();
  }

  function convertir(file, filename) {
    return file.async('blob')
      .then(function (content) {
        let ext = filename.substr(filename.lastIndexOf('.') + 1);

        return {
          ext: ext.toUpperCase(),
          filename: filename,
          content: content,
          contentType: ext === 'pdf' ? 'application/pdf' : 'application/xml',
        };
      });
  }

  function completado() {
    $zip().then(function (zip) {
      $ctrl.documentos.forEach(function (documento) {
        zip.file(documento.filename, documento.content)
      });

      return zip
        .generateAsync({type: 'blob', compression: 'DEFLATE', mimeType: 'application/zip'})
        .then(function (content) {
          $ctrl.zip = content;
        });
    }).finally(function () {
      $ctrl.completado = true;
    });
  }

  function guardar() {
    let filename = $ctrl.data.empresa + ' - Nóminas '
      + $filter('date')($ctrl.data.fecha_inicial, 'yyyy-MM-dd')
      + ' - '
      + $filter('date')($ctrl.data.fecha_final, 'yyyy-MM-dd')
      + '.zip';

    $file.saveAs($ctrl.zip, filename)
  }
}

angular.module('nominas.cfdi')
  .component('nominasCfdiDescargar', {
    template: template,
    controller: NominasCfdiDescargarComponent,
    bindings: {
      data: '<',
      seleccion: '<',
      onClose: '&',
    },
  });



// WEBPACK FOOTER //
// ./src/nominas/cfdi/components/descargar/component.js